<!-- PURPL ADMIN DASHBOARD -->
<admin-dashboard
  *ngIf="userService?.user?.position === 'purpl_admin'"
></admin-dashboard>

<!-- GENERIC Partners ACCESS Dashboard (LRC, NEXTCARE, AND CCI, IGNITIA for now) -->
<app-generic-partner-dashboard
  *ngIf="userService?.user?.position === 'partner'"
></app-generic-partner-dashboard>

<!-- BRAND MANAGER DASHBOARD -->
<brand-manager-dashboard
  *ngIf="
    userService?.user?.position !== 'purpl_admin' &&
    userService?.user?.position !== 'partner'
  "
></brand-manager-dashboard>
